import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IVisitor } from 'app/shared/Domains/visitor';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { AppServiceManager } from 'common/services/appServiceManager';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { IMemberFeeDetails } from 'app/shared/Domains/feeDetail';
import { ICompany } from 'app/shared/Domains/company';
import { IUser } from 'app/shared/Domains/IUser';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import globalVariable from "../../../globalVariable/globalVariable.json";
import { AppUtils } from 'common/services/app.util';
import { buildVisitorCreatePayload, buildVisitorDeleteFeePayload, buildVisitorPayFundPayload, buildVisitorUpdatePayload } from 'common/services/visitor-update-payload.util';
import { IBranch } from 'app/shared/Domains/branch';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-visitordialogue',
  templateUrl: 'visitordialouge.component.html',
  host: { "(window:keyup)": "hotkeys($event)", "(window:click)": "hotClick($event)" },
  styleUrls: ['visitordialouge.component.css']
})
export class VisitorDialogueComponent implements OnInit {
  @Input() dialogVisibility: any;
  @Output() closeVisitorDialog = new EventEmitter<any>();
  mode: string;
  visitor: IVisitor;
  fund: IMemberFeeDetails;
  @ViewChild("visitorName", { static: false }) visitorInput: ElementRef;
  company: ICompany;
  branch: IBranch;
  visitorID: any;
  errorExempleNumber: any;
  enterSteps: any[];
  currentStep: any;
  loading: boolean;
  display: boolean;
  isConfirmationBox: boolean;
  feeTotal: number;
  user: IUser;
  visitorFee: number = 0;
  visitorFeeDiscount: number = 0;
  visitorTypes: any = [
    // Your data goes here
  ];
  selectedVisitorType: any = null;
  selectedFees: any = '';
  selectedFeesObj: any = {};
  createdDate: Date;
  selectedDate: Date;
  paymentOptions: any;
  paymentMode: string;
  dayPass: any;
  trainingBySomeoneElse: any;
  allTrainers: any[];
  trainerName: string;
  selectedTrainer: any;
  discountTotal: number;
  selectedDayPass: boolean;
  whatsAppCommunityLink: any;
  whatsAppCommunityLinkMessage: string;

  constructor(
    private LanguageService: LanguageService,
    private route: ActivatedRoute,
    private router: Router,
    public config: Configuration,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private appServiceManager: AppServiceManager) {
    route.params.subscribe(
      params => {
        this.visitorID = params['id'];
        if (this.visitorID !== null && this.visitorID !== undefined) {
          this.mode = 'edit';
        } else {
          this.mode = 'add';
          this.breadcrumbService.setItems([
            { label: 'Visitor Management' },
            { label: 'All Visitors', routerLink: '/visitors' },
            { label: 'Add New Visitor' }
          ]);
        }
      }
    );
  }
	setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("VisitorDialogueComponent", label);
  }

  private visitorApiBase(): string {
    const branchId = this.user?.branch || AuthService.getLoggedInBranch();
    return 'branches/' + branchId + '/visitors';
  }

  ngOnInit() {
    this.errorExempleNumber = globalVariable.exampledata.pakNumber;
    this.user = AuthService.getLoggedInUser();
    this.getBranchById();
    this.getTrainers();
    this.visitor = new IVisitor();
    this.visitor.gender = 'M';
    this.company = new ICompany();
    this.fund = new IMemberFeeDetails();
    this.visitor.date = new Date();
    this.visitor.feeDetails = [];
    this.getCompany();
    this.currentStep = 0;
    this.isConfirmationBox = false;
    this.selectedDate = new Date();
    this.dayPass = "Default";
    this.selectedDayPass = false;
    this.dialogVisibility = true;
    this.paymentOptions = [
      { label: 'Cash - Reception', value: 'Cash-Reception' },
    ];
    this.paymentMode = "Cash-Reception";

    if (this.mode == 'edit') {
      this.enterSteps = [
        "visitorName",
        "visitorGender",
        "visitorEmail",
        "visitorMobile",
        // "visitorFee",
        "visitorUpdate",
        "dayPass"
      ];
      this.getVisitorByID();
    } else if (this.mode == 'add') {
      this.enterSteps = [
        "visitorName",
        "visitorGender",
        "visitorEmail",
        "visitorMobile",
        "visitorFee",
        "dayPass",
        "visitorSave"
      ];
    }

  }
  onSelect(event: any) {
    this.dayPass = event.value.name;
    this.fund.dayPass = event.value.name;
    this.visitor.dayPass = event.value.name;
    this.selectedFees = event.value.fees;
    this.selectedFeesObj = event.value;
    this.visitorFee = this.selectedFees
    this.selectedDayPass = true;
    console.log("event.value", event.value)
  }
  getBranchById() {
    this.appServiceManager.get('branches/' + this.user.branch).subscribe(
      (res) => {
        if (res) {
          this.branch=res;
          this.whatsAppCommunityLink = res.whatsappCommunityInvitationLink;
          this.whatsAppCommunityLinkMessage = "\n\nWe also have a vibrant WhatsApp community where our members share tips, motivation, and support each other's fitness journeys. If you'd like to join this community, simply tap on this link\n" + this.whatsAppCommunityLink;
          this.visitorTypes = res.visitorTypes;
          this.visitorFee = this.visitorTypes[0].fees;
          this.selectedFeesObj = this.visitorTypes[0];
          res.payments.forEach(payment => {
            const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
            if (!existingBank) {
              this.paymentOptions.push({
                label: `${payment.type} - ${payment.name}`,
                value: `${payment.type}-${payment.name}`
              });
            }
          });
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  ngAfterViewInit() {
    this.visitorInput.nativeElement.focus();
  }

  onBeforeDialogHide() {
    this.closeVisitorDialog.emit();
}

  getCompany() {
    this.appServiceManager.get('companies/current').subscribe((res) => {
      if (res) {
        this.company = res;
      } else {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  getVisitorByID() {
    this.appServiceManager.get(this.visitorApiBase() + "/" + this.visitorID).subscribe((res: any) => {
      if (res) {
        this.visitor = res;
        this.visitor.date = new Date(this.visitor.date);
        if (this.visitor.dateOfBirth) {
          this.visitor.dateOfBirth = new Date(this.visitor.dateOfBirth);
        }
        this.calculateTotal();
        this.breadcrumbService.setItems([
          { label: 'Visitor Management' },
          { label: 'All Visitors', routerLink: '/visitors' },
          { label: this.visitor.name }
        ]);
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  save(form: any) {
    if (form.valid) {
      this.isConfirmationBox = true;
      this.confirmationService.confirm({
        message: "Are you sure you want to save Visitor?",
        accept: () => {
          this.isConfirmationBox = false;
          this.fund.pay = this.visitorFee;
          if (this.fund.pay !== null && this.fund.pay > 0) {
            var date = new Date();
            this.fund.createdDate = date;
            this.fund.date = this.selectedDate;
            this.fund.createdBy = this.user.name;
            this.fund.discount = this.visitorFeeDiscount;
            this.fund.status = "Visiting Fee - Paid";
            this.fund.isDelete = false;
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth() + 1;
            const currentYear = currentDate.getFullYear();
            this.fund.invoice = null;
            this.fund.paymentMode = this.paymentMode;
            this.fund.trainerName = this.trainerName;
            this.fund.invoice = AppUtils.generateInvoiceNo(this.visitor.name, this.visitor.feeDetails, currentYear, currentMonth, true);
            this.visitor.company = this.user.company;
            this.visitor.branch = this.user.branch;
            if(!this.selectedDayPass){
              this.fund.dayPass = this.visitorTypes[0].name;
              this.visitor.dayPass = this.visitorTypes[0].name;
              }
            let data = { fund: this.fund, packageObj: this.selectedFeesObj };
            // this.visitor.feeDetails.push(this.fund);
            this.visitor.createdBy = this.user._id;
            this.visitor.dayPass = this.dayPass;
            this.appServiceManager.post(this.visitorApiBase() + "/", buildVisitorCreatePayload(this.visitor)).subscribe((res: any) => {
              if (res) {
                if (res.isAlreadyExist) {
                  // this.visitor.feeDetails = [];
                  this.messageService.clear();
                  this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Visitor with this name and contact already exists.Only fee details are updated' });
                }
                  this.visitor = res.visitor;
                  this.visitorID = res.visitor._id;
                  this.addFundDb(data);
                  this.visitor.date = new Date(this.visitor.date);
                  if (this.visitor.dateOfBirth) {
                    this.visitor.dateOfBirth = new Date(this.visitor.dateOfBirth);
                  }
                  this.calculateTotal();
                  if(!res.isAlreadyExist){
                  this.messageService.clear();
                  this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Visitor Successfully Registered' });
                  // this.printInvoice();
                  // this.router.navigateByUrl('visitors')
                  }
              } else {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
              }
            },
              (error) => {
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
              });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Visiting Fee Must be greater then zero.' });
          }
        },
        reject: () => {
          this.isConfirmationBox = false;
        }
      });
    }
    else {
      //  // Form validation error handling
      Object.keys(form.controls).forEach(controlName => {
        const control = form.controls[controlName];
        control.markAsTouched(); // Mark the control as touched to display the validation error messages
      });
    }
  }
  update(form: any) {
    if (form.valid) {
      this.isConfirmationBox = true;
      this.confirmationService.confirm({
        message: "Are you sure you want to update Visitor?",
        accept: () => {
          this.isConfirmationBox = false;
          this.visitor.company = this.user.company;
          this.visitor.branch = this.user.branch;
          const updatePayload = buildVisitorUpdatePayload(this.visitor, { includeCompanyBranch: true });
          this.appServiceManager.patch(this.visitorApiBase() + "/" + this.visitor._id, updatePayload).subscribe((res: any) => {
            if (res) {
              if (res.isAlreadyExist) {
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Visitor with this name and contact already exists.' });
              }
              else {
                this.visitor = res.visitor;
                this.visitor.date = new Date(this.visitor.date);
                if (this.visitor.dateOfBirth) {
                  this.visitor.dateOfBirth = new Date(this.visitor.dateOfBirth);
                }
                this.messageService.clear();
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Visitor Successfully Updated' });
              }
            } else {
              this.messageService.clear();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
          },
            (error) => {
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        },
        reject: () => {
          this.isConfirmationBox = false;
        }
      });
    }
    else {
      //  // Form validation error handling
      Object.keys(form.controls).forEach(controlName => {
        const control = form.controls[controlName];
        control.markAsTouched(); // Mark the control as touched to display the validation error messages
      });
    }
  }
  openWhatsApp(): string {
    let reciever = this.visitor.phone;
    if (this.visitor.phone) {
      let sessionData = localStorage.getItem('currentCompany');
      let parsedData = JSON.parse(sessionData);
      let name = parsedData.name;
      let msg = this.config.jackedVisitorMessage;
      msg = msg.replace("{0}", this.visitor.name);
      msg = msg.replace("{1}", name);
      if (this.whatsAppCommunityLink) {
        msg = msg.replace("{2}", this.whatsAppCommunityLinkMessage);
      } else {
        msg = msg.replace("{2}", '');
      }
      const message = encodeURIComponent(msg);
        const link = document.createElement('a');
        link.href = `https://wa.me/${reciever}?text=${message}`;
        link.target = '_blank';
        link.click();
        return '';
    } else {
      // Show error message here
      this.messageService.clear();
      this.messageService.add({
        severity: "error",
        summary: "Error Message",
        detail: 'This user does not have a phone number',
      });
      return '';
    }
  }
  displayFund() {
    this.fund.pay = 0;
    this.display = true;
  }
  deactivateVisitor() {
      this.confirmationService.confirm({
        message: "Are you sure you want to Deactivate Visitor?",
        accept: () => {
          this.loading = true;
          this.appServiceManager.delete(this.visitorApiBase() + '/' + this.visitor._id).subscribe((res: any) => {
            if (res.status === true) {
              this.messageService.clear();
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Deactivated' });
            } else {
              this.messageService.clear();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
            this.loading = false;
          },
            (error) => {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        }
      });
    }
  addFund() {
    //this.getVisitorByID();
    this.fund.pay = this.visitorFee;
    if (this.fund.pay !== null && this.fund.pay > 0) {
      var date = new Date();
      this.fund.createdDate = date;
      this.fund.date = this.selectedDate;
      if(!this.selectedDayPass){
      this.fund.dayPass = this.visitorTypes[0].name;
      }
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      const currentYear = currentDate.getFullYear();
      this.fund.invoice = AppUtils.generateInvoiceNo(this.visitor.name, this.visitor.feeDetails, currentYear, currentMonth, true);
      this.fund.status = "Visiting Fee - Paid";
      this.fund.paymentMode = this.paymentMode;
      this.fund.discount = this.visitorFeeDiscount;
      this.fund.type = this.selectedFeesObj._id;
      this.fund.trainerName = this.trainerName;
      this.fund.createdBy = this.user.name;
      this.fund.isDelete = false;
      this.visitor.feeDetails.push(this.fund);
      this.display = false;
      let user = JSON.parse(localStorage.getItem('currentUser'));
      this.visitor.company = user.company;
      this.visitor.branch = user.branch;
      let data = { fund: this.fund, packageObj: this.selectedFeesObj };
      this.addFundDb(data);
    } else {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Visiting Fee Must be greater then zero.' });
    }
  }
  addFundDb(data) {
    const payFundPayload = buildVisitorPayFundPayload(data.fund, data.packageObj, {
      scope: 'Visitor',
      branchId: this.user?.branch || AuthService.getLoggedInBranch(),
      initiatedFrom: 'Add Visitor',
      name: this.visitor.name,
    });
    this.appServiceManager.post(this.visitorApiBase() + "/" + this.visitor._id + "/actions/pay-fund", payFundPayload).subscribe((res: any) => {
      if (res) {
        this.visitor = res.visitor;
        setTimeout(() => {
          this.printInvoice();
        }, 200);
        if(!this.selectedDayPass){
          this.visitor.dayPass = this.visitorTypes[0].name;
          }
        this.visitor.date = new Date(this.visitor.date);
        if (this.visitor.dateOfBirth) {
          this.visitor.dateOfBirth = new Date(this.visitor.dateOfBirth);
        }
        setTimeout(() => {
          this.visitor = new IVisitor();
          this.getVisitorByID();
        }, 200);
        this.calculateTotal();
        this.messageService.clear();
        this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Visitor Successfully Updated' });
      } else {
        this.display = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.display = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  deletevisitorFees(fee: IMemberFeeDetails){
    this.confirmationService.confirm({
      message: "Are you sure you want to Delete Fee?",
      accept: () => {
        var visitor = buildVisitorDeleteFeePayload(
          this.visitor._id,
          fee as unknown as Record<string, unknown>,
          this.user as unknown as Record<string, unknown>,
        );
      this.appServiceManager
      .post(this.visitorApiBase() + "/actions/delete-fee", visitor)
      .subscribe(
          (response: any) => {
              const index: number =
                  this.visitor.feeDetails.indexOf(fee);
              if (index !== -1) {
                  this.visitor.feeDetails.splice(index, 1);
              }
              this.loading = false;
              this.getVisitorByID();
              this.messageService.clear();
              this.messageService.add({
                  severity: "success",
                  summary: "Success Message",
                  detail: "Fee Successfully Deleted",
              });
          },
          (error) => {
              this.loading = false;
          }
      );
},
});

  }
  onPaymentModeChange(value: string) {
    this.paymentMode = value;
  }
  hotkeys($event) {
    if ($event.keyCode == 39 || $event.keyCode == 37) {
      var confirmationBox = document.getElementsByTagName("p-confirmdialog")[0];
      var confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
      var confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;
      if (confirmationBoxButtonExistLength > 0) {
        if (document.activeElement.tagName === "BODY") {
          confirmationBoxButtonExist[0].focus();
        }
        else {
          if (document.activeElement === confirmationBoxButtonExist[0]) {
            confirmationBoxButtonExist[1].focus();
          }
          else if (document.activeElement === confirmationBoxButtonExist[1]) {
            confirmationBoxButtonExist[0].focus();
          }
          else {
            confirmationBoxButtonExist[0].focus();
          }
        }
      }
    }

    else if ($event.keyCode == 13 && !this.isConfirmationBox) {
      var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
      var nextId = this.enterSteps[nextStep];
      let ele: any = document.getElementById(nextId)
      if (ele == null && nextId == "visitorFee" && this.mode == "edit") {
        document.getElementById("visitorUpdate").focus();
        this.currentStep = 0 - 1;
      }
      else if (nextId == "visitorGender") {
        let radioClassFocus: any = document.getElementsByClassName("p-highlight")[1] as HTMLElement;
        radioClassFocus.click();
        this.currentStep = 1;
      } else if (ele.disabled && nextId == "visitorSave") {
        document.getElementById("visitorName").focus();
        this.currentStep = 0;

      } else if (ele.disabled && nextId == "visitorUpdate") {
        document.getElementById("visitorName").focus();
        this.currentStep = 0;

      } else {
        ele.focus();
        this.currentStep = nextStep;
      }
    }
    else if ($event.keyCode == 113) {
      this.router.navigateByUrl("/visitor");
      this.visitor.name = "";
      this.visitor.email = "";
      this.visitor.phone = "";
      this.visitor.gender = 'M';
      this.fund.pay = undefined;
      this.visitor.date = new Date();
      document.getElementById("visitorName").focus();
      this.currentStep = 0;
    }
  }

  getTrainers() {
    this.allTrainers = [];
    this.loading = true;
    this.appServiceManager
      .get("branches/" + this.user.branch + "/users")
      .subscribe(
        (res) => {
          if (res.length > 0) {
            // this.trainerDropDown(res);
            this.allTrainers = res;
            this.allTrainers = res.filter(element => element?.role === 'Trainer');
          } else {
            this.messageService.clear();
            this.messageService.add({
              severity: "info",
              summary: "Info Message",
              detail: "No Record Found",
            });
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error,
          });
        }
      );
  }

  onCheckboxChange() {
    if (this.trainingBySomeoneElse) {
      this.trainingBySomeoneElse = false;
    }
    else {
      this.trainingBySomeoneElse = true;
    }
  }

  onConductedTrainerChange(event) {
    this.selectedTrainer = event.value;
    this.trainerName = this.selectedTrainer.name;
  }

  hotClick($event) {
    let currentClickLocation = $event.target.id;
    let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
    if (indexOfClickField !== -1 && (currentClickLocation != "opt1" || currentClickLocation != "opt2")) {
      this.currentStep = indexOfClickField;
    } else if (currentClickLocation == "visitorAddNew") {
      this.visitor.name = "";
      this.visitor.email = "";
      this.visitor.phone = "";
      this.visitor.gender = 'M';
      this.fund.pay = undefined;
      this.visitor.date = new Date();
      document.getElementById("visitorName").focus();
      this.currentStep = 0;
    } else {
      this.currentStep = this.currentStep;
    }
  }

  calculateTotal() {
    this.feeTotal = 0;
    this.discountTotal = 0;
    if (this.visitor.feeDetails) {
      if (this.visitor.feeDetails.length > 0) {
        this.visitor.feeDetails.forEach((record) => {
          this.feeTotal += parseInt(record.pay.toString());
          this.discountTotal += parseInt(record.discount.toString());
        });
      }
    }
    this.feeTotal = this.feeTotal - this.discountTotal;
  }
  viewPrint(fund) {
    this.fund = new IMemberFeeDetails();
    this.fund = fund;
    setTimeout(() => {
      this.printInvoice();
    }, 200);
  }
  printInvoice(): void {
    let printContents, popupWin;
    printContents = document.getElementById('invoice').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <head>
        <title>Gym Invoice</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>
        ${printContents}</body>
    </html>
    `
    );
  }
}
